import HeroError from '../../../../assets/hero-error.svg';
import { withMatchMedia } from '../../../../providers/context/MatchMediaProvider/withMatchMedia';
import { ButtonGroup, ButtonGroupProps } from '../../ButtonGroup/ButtonGroup';
import {
  ButtonGroupContainer,
  Card,
  CardDescription,
  CardTitle,
  ContentContainer,
  Image,
  ImageContainer,
} from './styles';

export const FailedSubmissionActionCardComponent = ({
  isDesktop,
  isMobile,
  isTablet,
  isVerticallyAligned,
  buttonGroup,
}: {
  isDesktop?: boolean;
  isMobile?: boolean;
  isTablet?: boolean;
  isVerticallyAligned?: boolean;
  buttonGroup: ButtonGroupProps;
}) => {
  const title = "Something's not quite right";
  const description =
    'We were unable to import your application successfully. Please try again, and if the issue persists, please contact our team for help.';

  return (
    <Card
      $isMobile={isMobile}
      $isVerticallyAligned={isVerticallyAligned}
      data-testid="actionCard"
    >
      <ImageContainer
        $isMobile={isMobile}
        $isTablet={isTablet}
        $isVerticallyAligned={isVerticallyAligned}
      >
        <Image src={HeroError} />
      </ImageContainer>
      <ContentContainer $isMobile={isMobile}>
        <CardTitle>{title}</CardTitle>
        <CardDescription title={description}>{description}</CardDescription>

        <ButtonGroupContainer
          $isDesktop={isDesktop}
          $isVerticallyAligned={isVerticallyAligned || isMobile}
        >
          <ButtonGroup
            {...{
              ...buttonGroup,
              isVerticallyAligned: isVerticallyAligned || isMobile,
            }}
          />
        </ButtonGroupContainer>
      </ContentContainer>
    </Card>
  );
};

export const FailedSubmissionActionCard = withMatchMedia(
  FailedSubmissionActionCardComponent,
);
